import { Vue, Component, Watch } from "vue-property-decorator";
import { FilterOperator } from "@/models/FilterOperator";
import { POSParameter } from "@/models/POSParameter";

type ArchNotifyType = "error" | "success" | "warning";
type Rules = (val: any) => string | boolean;

@Component
export default class IndexMixin extends Vue {
  public hotelId: number = Number(this.$route.query.hotelId) || 0;
  public outletId: number = Number(this.$route.query.outletId) || 0;
  public tableName: string = "";

  public codeErrors: any = [];
  public data: any; // from props
  public formData: any = {}; // cloned from props

  public posUrl(table: string, params: string = "") {
    return `/hotel/{hotelId}/dto/pos.${table}/v1?${params}`;
  }

  public publicUrl(table: string, params: string = "") {
    return `/hotel/{hotelId}/dto/${table}/v1?${params}`;
  }
  public get importUrl(): string {
    return `/hotel/{hotelId}/dto/pos.${this.tableName}`;
  }
  public notify(close: boolean=  true, msg: string = "", clr: ArchNotifyType = "success", timeout = 3000): void {
    this.$archNotify({
      showClose: close,
      message: msg,
      color: clr,
      timeout
    });
  }

  public warnNotify(msg: string = "", timeout = 3000) {
    this.notify(true, msg, "warning", timeout);
  }

  public errNotify(msg: string = "", timeout = 3000) {
    this.notify(true, msg, "error", timeout );
  }

  public succNotify(msg: string = "", timeout = 3000) {
    this.notify(true, msg, "success", timeout);
  }

  public defNotify(msg: string = "", timeout = 3000) {
    this.notify(true, msg, "success", timeout);
  }

  public currencySymbol(): string {
    return typeof this.$store.state.app.hotel.currency_symbol !== "undefined"? `(${this.$store.state.app.hotel.currency_symbol})` : " ";
  }

  public routePush(routeName: string, prm: any) {
    this.$router.push({ name: routeName, params: prm }, () => {});
  }

  public codeRules: Rules[] = [
    (v) => !!v || "Code is required",
    (v) =>
      (v && v.length <= 10) || "Code must not be longer than 10 characters",
  ];

  public nameRules: Rules[] = [(v) => !!v || "Field is required"];

  public submitMe() {
  }

  public typingCode: boolean = false;
  @Watch("formData.code")
  watchCode(nVal: string, oVal: string) {
    if (!this.typingCode) {

      if (!nVal || nVal.length < 1 || !this.tableName || this.tableName.length <= 1) {
        return false;
      }

      setTimeout(() => {
        const filters = {
          filter_by: ["code"],
          filter_by_value: [this.formData.code],
          filter_by_operator: [FilterOperator.Equal],
        };
        this.$http.get(
          `/hotel/{hotelId}/dto/pos.${this.tableName}/v1`,
          filters
        ).then((r) => {

          if (r.data.Data && r.data.Data.length > 0) {
            if (this.formData.id && this.formData.id > 0) {
              if (r.data.Data.length == 1  && this.data.code == r.data.Data[0].code) {
                this.codeErrors = [];
              } else if (r.data.Data.length == 1  && this.data.code != r.data.Data[0].code) {
                this.codeErrors = [`Code ${this.formData.code} already used`];
              } else {
                this.codeErrors = [];
              }
            } else {
              if (r.data.Data.length <= 0) {
                this.codeErrors = [];
              } else {
                this.codeErrors = [`Code ${this.formData.code} already used`];
              }
            }
          } else {
            this.codeErrors = [];
          }
        });

        this.typingCode = false;
      }, 1000); // 1 sec delay
    }
    this.typingCode = true;
  }
  public async getParameter(): Promise<POSParameter> {
    return this.$http
      .get(`/hotel/{hotelId}/dto/pos.parameter/v1?filter_by[]=outlet_id&filter_operator[]=${FilterOperator.Equal}&filter_by_value[]=${this.outletId}`)
      .then((res) => {
        return new Promise((resolve: any, reject) => {
          if (res.data.Data?.length) {
            resolve(res.data.Data[0]);
          } else {
            this.$archNotify({
              showClose: true,
              message: this.$t("sharedCommon.itemNotFound", { item: this.$t("sharedCommon.POSParameter") }).toString(),
              color: "error",
            });
            reject(this.$t("sharedCommon.itemNotFound", { item: this.$t("sharedCommon.POSParameter") }));
          }
        });
      });
  }
}
